// https://fjolt.com/article/javascript-how-to-validate-an-email
/*
 Email validation regex RFC5322, successor to RFC822 is much shorter and easier to use. 
 The function below will validate any email put into it:
*/

export const isValidEmail = (email: string) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};
